import { toAbsoluteUrl } from '../../_helpers'
export function getInitLayoutConfig() {
	return {
		demo: 'demo1',
		js: {
			breakpoints: {
				sm: '576',
				md: '768',
				lg: '992',
				xl: '1200',
				xxl: '1200',
			},
			colors: {
				theme: {
					base: {
						white: '#ffffff',
						primary: '#4f5248',
						secondary: '#e2ddd4',
						success: '#5cb23a',
						info: '#2f9fd0',
						warning: '#f5a800',
						danger: '#F64E60',
						light: '#f8f6f2',
						dark: '#2f322c',
					},
					light: {
						white: '#ffffff',
						primary: '#efeae1',
						secondary: '#f8f6f2',
						success: '#f3faf0',
						info: '#eef6fb',
						warning: '#fff8e6',
						danger: '#FFE2E5',
						light: '#f8f6f2',
						dark: '#e2ddd4',
					},
					inverse: {
						white: '#ffffff',
						primary: '#ffffff',
						secondary: '#2f322c',
						success: '#ffffff',
						info: '#ffffff',
						warning: '#2f322c',
						danger: '#ffffff',
						light: '#2a2d26',
						dark: '#ffffff',
					},
				},
				gray: {
					gray100: '#f8f6f2',
					gray200: '#efeae1',
					gray300: '#e2ddd4',
					gray400: '#D6D6E0',
					gray500: '#5a5d54',
					gray600: '#5a5d54',
					gray700: '#2a2d26',
					gray800: '#2f322c',
					gray900: '#2a2d26',
				},
			},
			fontFamily: 'Arial',
		},
		// == Page Splash Screen loading
		loader: {
			enabled: true,
			type: '', // default|spinner-message|spinner-logo
			logo: toAbsoluteUrl('/media/logo/logo2_turismo.png'),
			message: 'Cargando...',
		},
		// page toolbar
		toolbar: {
			display: true,
		},
		header: {
			self: {
				width: 'fluid', // fixed|fluid
				theme: 'light', // light|dark
				fixed: {
					desktop: true,
					mobile: true,
				},
			},
			menu: {
				self: {
					display: true,
					layout: 'default', // tab/default
					'root-arrow': false,
					'icon-style': 'duotone', // duotone, line, bold, solid
				},
				desktop: {
					arrow: true,
					toggle: 'click',
					submenu: {
						theme: 'light', // light|dark
						arrow: true,
					},
				},
				mobile: {
					submenu: {
						theme: 'dark',
						accordion: true,
					},
				},
			},
		},
		subheader: {
			display: true,
			displayDesc: false,
			displayDaterangepicker: true,
			layout: 'subheader-v1',
			fixed: true,
			width: 'fluid', // fixed/fluid,
			clear: false,
			style: 'solid', // solid/transparent
		},
		content: {
			width: 'fixed', // fluid|fixed
		},
		brand: {
			self: {
				theme: 'dark', // light/dark
			},
		},
		aside: {
			self: {
				theme: 'dark', // light/dark
				display: true,
				fixed: true,
				minimize: {
					toggle: true, // allow toggle
					default: false, // default state
					hoverable: true, // allow hover
				},
			},
			footer: {
				self: {
					display: true,
				},
			},
			menu: {
				dropdown: false, // ok
				scroll: true, // ok
				'icon-style': 'duotone', // duotone, line, bold, solid
				submenu: {
					accordion: true,
					dropdown: {
						arrow: true,
						'hover-timeout': 500, // in milliseconds
					},
				},
			},
		},
		footer: {
			self: {
				fixed: true,
				width: 'fluid',
			},
		},
		// LAYOUT CONFIG HERE ARE THE EXTRAS
		extras: {
			// search: {
			//   display: true,
			//   layout: "dropdown", // offcanvas, dropdown
			//   offcanvas: {
			//     direction: "right",
			//   },
			// },
			// notifications: {
			//   display: true,
			//   layout: "dropdown", // offcanvas, dropdown
			//   dropdown: {
			//     style: "dark", // light, dark
			//   },
			//   offcanvas: {
			//     directions: "right",
			//   },
			// },
			// "quick-actions": {
			//   display: true,
			//   layout: "dropdown", // offcanvas, dropdown,
			//   dropdown: {
			//     style: "dark", // light, dark
			//   },
			//   offcanvas: {
			//     directions: "right",
			//   },
			// },
			user: {
				display: true,
				layout: 'dropdown', // offcanvas, dropdown
				dropdown: {
					style: 'dark',
				},
				offcanvas: {
					directions: 'right',
				},
			},
			languages: {
				display: false, // LANGUAGES SELECTOR
			},
			// cart: {
			//   display: true,
			//   dropdown: {
			//     style: "dark", // ligth, dark
			//   },
			// },
			// "quick-panel": {
			//   display: true,
			//   offcanvas: {
			//     directions: "right",
			//   },
			// },
			chat: {
				display: true,
			},
			toolbar: {
				display: true,
			},
			scrolltop: {
				display: true,
			},
		},
	}
}
